class FeatureManager extends EventTarget {
  constructor(_features = {}) {
    super(), this._features = _features, this.updateFeature = (feature, enabled = !0) => {
      this._features[feature] !== enabled && (this._features = { ...this._features, [feature]: enabled }, this.dispatchEvent(new FeaturesUpdatedEvent(this.features)));
    }, this.isEnabled = (featureName) => !!this._features[featureName], this.enableAll = () => {
      this.forEachFeature((key, enabled) => {
        enabled || this.updateFeature(key);
      });
    }, this.disableAll = () => {
      this.forEachFeature((key, enabled) => {
        enabled && this.updateFeature(key, !1);
      });
    }, this.forEachFeature = (cb) => {
      Object.entries(this._features).forEach(([key, enabled]) => cb(key, enabled));
    };
  }
  /** Returns current features */
  get features() {
    return { ...this._features };
  }
}
const _FeaturesUpdatedEvent = class _FeaturesUpdatedEvent2 extends CustomEvent {
  constructor(features) {
    super(_FeaturesUpdatedEvent2.type, { detail: features });
  }
};
_FeaturesUpdatedEvent.type = "features-updated";
let FeaturesUpdatedEvent = _FeaturesUpdatedEvent;
export {
  FeatureManager,
  FeaturesUpdatedEvent
};
//# sourceMappingURL=FeatureManager.js.map
